module.exports = __webpack_public_path__ + "static/media/choon_Screen1.0783b54c.png";